import { render, staticRenderFns } from "./OrderPaymentEditor.vue?vue&type=template&id=a9980404"
import script from "./OrderPaymentEditor.vue?vue&type=script&lang=js"
export * from "./OrderPaymentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports